/**
 * @generated SignedSource<<8db160f5faf236b47c9aaf08f275599e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ResetCompanyToExpiredTrialInput = {
  companyId: number;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type resetCompanyToExpiredTrialMutation$variables = {
  input: ResetCompanyToExpiredTrialInput;
};
export type resetCompanyToExpiredTrialMutation$data = {
  readonly ResetCompanyToExpiredTrial: {
    readonly companyId: number | null;
    readonly tier: string | null;
  } | null;
};
export type resetCompanyToExpiredTrialMutation = {
  variables: resetCompanyToExpiredTrialMutation$variables;
  response: resetCompanyToExpiredTrialMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ResetCompanyToExpiredTrialPayload",
    "kind": "LinkedField",
    "name": "ResetCompanyToExpiredTrial",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "companyId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "tier",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "resetCompanyToExpiredTrialMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "resetCompanyToExpiredTrialMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1e130d941e7a39eb226de9cadeb9a52a",
    "id": null,
    "metadata": {},
    "name": "resetCompanyToExpiredTrialMutation",
    "operationKind": "mutation",
    "text": "mutation resetCompanyToExpiredTrialMutation(\n  $input: ResetCompanyToExpiredTrialInput!\n) {\n  ResetCompanyToExpiredTrial(input: $input) {\n    companyId\n    tier\n  }\n}\n"
  }
};
})();

(node as any).hash = "698cc22465579b9d48517ef97efc8fb1";

export default node;
